import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./Dashboard.css";
import { getDashboardStats } from "./api/dashboardApi";

export default function Dashboard() {
const [stats, setStats] = useState({
websiteUsers: 0,
discordMembers: 0,
downloads: 0,
onlinePlayers: 0,
});

const [loading, setLoading] = useState(false);
const [activeAdminPanel, setActiveAdminPanel] = useState(null);

/* =========================
USER / ADMIN
========================= */

const user = useMemo(() => {
try {
const savedUser = localStorage.getItem("user");


  if (!savedUser) {
    return null;
  }

  return JSON.parse(savedUser);
} catch (error) {
  console.error("Unable to read logged-in user:", error);
  return null;
}


}, []);

const isAdmin =
user?.isAdmin === true ||
user?.admin === true ||
user?.role?.toLowerCase?.() === "admin";

/* =========================
SAFE NUMBER
========================= */

const safeNumber = (value) => {
const number = Number(value);


if (!Number.isFinite(number)) {
  return 0;
}

return number;


};

/* =========================
LOAD DASHBOARD
========================= */

const loadDashboard = useCallback(() => {
setLoading(true);


getDashboardStats()
  .then((res) => {
    console.log("Dashboard API:", res.data);

    const data = res.data || {};

    setStats({
      websiteUsers: safeNumber(data.websiteUsers),
      discordMembers: safeNumber(data.discordMembers),
      downloads: safeNumber(data.downloads),
      onlinePlayers: safeNumber(data.onlinePlayers),
    });
  })
  .catch((err) => {
    console.error("Dashboard API Error:", err);

    setStats({
      websiteUsers: 0,
      discordMembers: 0,
      downloads: 0,
      onlinePlayers: 0,
    });
  })
  .finally(() => {
    setLoading(false);
  });


}, []);

useEffect(() => {
loadDashboard();
}, [loadDashboard]);

/* =========================
DASHBOARD CARDS
========================= */

const dashboardCards = [
{
title: "Website Users",
value: stats.websiteUsers,
icon: "👤",
description: "Registered users",
className: "users",
},
{
title: "Discord Members",
value: stats.discordMembers,
icon: "💬",
description: "Community members",
className: "discord",
},
{
title: "Downloads",
value: stats.downloads,
icon: "↓",
description: "Total addon downloads",
className: "downloads",
},
{
title: "Online Players",
value: stats.onlinePlayers,
icon: "🎮",
description: "Players currently online",
className: "players",
},
];

/* =========================
ADMIN PANELS
========================= */

const adminPanels = {
users: {
title: "User Management",
icon: "👥",
description: "View and manage registered Vortex Network users.",
content: ( <div className="admin-panel-content"> <div className="admin-placeholder"> <div className="admin-placeholder-icon">👥</div>


        <h3>User Management</h3>

        <p>
          This is where you can manage website users, permissions,
          accounts and administrator access.
        </p>

        <div className="admin-panel-stats">
          <div>
            <strong>
              {safeNumber(stats.websiteUsers).toLocaleString()}
            </strong>
            <span>Registered Users</span>
          </div>

          <div>
            <strong>ADMIN</strong>
            <span>Your Access Level</span>
          </div>
        </div>

        <button
          className="admin-panel-button"
          onClick={() => {
            alert("User management is connected to this dashboard.");
          }}
        >
          Manage Users
        </button>
      </div>
    </div>
  ),
},

posts: {
  title: "Post Management",
  icon: "📝",
  description: "Manage forum posts and community content.",
  content: (
    <div className="admin-panel-content">
      <div className="admin-placeholder">
        <div className="admin-placeholder-icon">📝</div>

        <h3>Post Management</h3>

        <p>
          Manage Vortex Network forum posts, announcements and
          community content from the administrator dashboard.
        </p>

        <div className="admin-panel-stats">
          <div>
            <strong>FORUM</strong>
            <span>Community Content</span>
          </div>

          <div>
            <strong>ADMIN</strong>
            <span>Management Access</span>
          </div>
        </div>

        <button
          className="admin-panel-button"
          onClick={() => {
            window.location.href = "/forums";
          }}
        >
          Open Forum
        </button>
      </div>
    </div>
  ),
},

addons: {
  title: "Addon Management",
  icon: "⚡",
  description: "Manage Vortex Network addon releases.",
  content: (
    <div className="admin-panel-content">
      <div className="admin-placeholder">
        <div className="admin-placeholder-icon">⚡</div>

        <h3>Addon Management</h3>

        <p>
          Manage your Vortex Network addons, releases, versions and
          download information.
        </p>

        <div className="admin-panel-stats">
          <div>
            <strong>
              {safeNumber(stats.downloads).toLocaleString()}
            </strong>
            <span>Total Downloads</span>
          </div>

          <div>
            <strong>VORTEX</strong>
            <span>Addon System</span>
          </div>
        </div>

        <button
          className="admin-panel-button"
          onClick={() => {
            window.location.href = "/addons";
          }}
        >
          Open Addons
        </button>
      </div>
    </div>
  ),
},

settings: {
  title: "Website Settings",
  icon: "⚙",
  description: "Configure Vortex Network website settings.",
  content: (
    <div className="admin-panel-content">
      <div className="admin-placeholder">
        <div className="admin-placeholder-icon">⚙</div>

        <h3>Website Settings</h3>

        <p>
          Configure website-wide settings, API options, community
          settings and other Vortex Network options.
        </p>

        <div className="admin-settings-list">
          <div className="admin-setting-row">
            <span>
              <strong>Website</strong>
              <small>Vortex Network</small>
            </span>

            <span className="setting-status">
              ONLINE
            </span>
          </div>

          <div className="admin-setting-row">
            <span>
              <strong>API</strong>
              <small>PHP Backend</small>
            </span>

            <span className="setting-status">
              ONLINE
            </span>
          </div>

          <div className="admin-setting-row">
            <span>
              <strong>Community</strong>
              <small>Discord</small>
            </span>

            <span className="setting-status">
              ONLINE
            </span>
          </div>
        </div>

        <button
          className="admin-panel-button"
          onClick={() => {
            alert("Website settings panel is ready to be connected.");
          }}
        >
          Configure Settings
        </button>
      </div>
    </div>
  ),
},


};

return ( <div className="dashboard-page">


  {/* =========================
      HEADER
  ========================= */}

  <div className="dashboard-header">

    <div className="dashboard-title-area">

      <div className="dashboard-title-icon">
        ⚡
      </div>

      <div>

        <div className="dashboard-breadcrumb">
          VORTEX NETWORK / DASHBOARD
        </div>

        <h1>Dashboard</h1>

        <p>
          Welcome back
          {user?.username ? `, ${user.username}` : ""}.
          {" "}Here's what's happening across Vortex Network.
        </p>

      </div>

    </div>

    <button
      className="dashboard-refresh"
      onClick={loadDashboard}
      disabled={loading}
    >
      <span className={loading ? "refresh-spinning" : ""}>
        ↻
      </span>

      {loading ? "Refreshing..." : "Refresh"}
    </button>

  </div>

  {/* =========================
      STATUS BAR
  ========================= */}

  <div className="dashboard-status-bar">

    <div className="status-item">
      <span className="status-dot online"></span>
      <span>Website Online</span>
    </div>

    <div className="status-item">
      <span className="status-dot online"></span>
      <span>API Online</span>
    </div>

    <div className="status-item">
      <span className="status-dot online"></span>
      <span>Community Online</span>
    </div>

    <div className="status-time">
      Last updated automatically
    </div>

  </div>

  {/* =========================
      STATISTICS
  ========================= */}

  <section className="dashboard-section">

    <div className="dashboard-section-heading">

      <div>
        <span className="section-label">
          OVERVIEW
        </span>

        <h2>Network Statistics</h2>
      </div>

    </div>

    <div className="dashboard-stats">

      {dashboardCards.map((card) => (

        <div
          className={`dashboard-card ${card.className}`}
          key={card.title}
        >

          <div className="dashboard-card-glow"></div>

          <div className="dashboard-card-top">

            <div className="dashboard-card-icon">
              {card.icon}
            </div>

            <span className="dashboard-card-arrow">
              ↗
            </span>

          </div>

          <div className="dashboard-card-content">

            <span className="dashboard-card-label">
              {card.title}
            </span>

            <div className="dashboard-card-value">
              {safeNumber(card.value).toLocaleString()}
            </div>

            <p>
              {card.description}
            </p>

          </div>

        </div>

      ))}

    </div>

  </section>

  {/* =========================
      QUICK ACTIONS
  ========================= */}

  <section className="dashboard-section">

    <div className="dashboard-section-heading">

      <div>
        <span className="section-label">
          SHORTCUTS
        </span>

        <h2>Quick Actions</h2>
      </div>

    </div>

    <div className="dashboard-actions">

      <button
        className="dashboard-action"
        onClick={() => {
          window.location.href = "/forums";
        }}
      >
        <span className="action-icon">💬</span>

        <span>
          <strong>Forum</strong>
          <small>View community posts</small>
        </span>

        <span className="action-arrow">→</span>
      </button>

      {/* <button
        className="dashboard-action"
        onClick={() => {
          window.location.href = "/downloads";
        }}
      >
        <span className="action-icon">↓</span>

        <span>
          <strong>Downloads</strong>
          <small>Manage addon downloads</small>
        </span>

        <span className="action-arrow">→</span>
      </button> */}

      <button
        className="dashboard-action"
        onClick={() => {
          window.location.href = "/addons";
        }}
      >
        <span className="action-icon">◆</span>

        <span>
          <strong>Addons</strong>
          <small>View Vortex addons</small>
        </span>

        <span className="action-arrow">→</span>
      </button>

    </div>

  </section>

  {/* =========================
      ADMIN CONTROL CENTER
  ========================= */}

  {isAdmin && (

    <section className="dashboard-section admin-section">

      <div className="dashboard-section-heading">

        <div>
          <span className="section-label admin-label">
            ADMINISTRATOR
          </span>

          <h2>Admin Control Center</h2>

          <p>
            Manage the Vortex Network website directly from this
            dashboard.
          </p>
        </div>

        <div className="admin-badge">
          🛡 ADMIN
        </div>

      </div>

      {/* ADMIN CARDS */}

      <div className="admin-grid">

        {Object.entries(adminPanels).map(([key, panel]) => (

          <button
            key={key}
            className={`admin-card ${
              activeAdminPanel === key
                ? "admin-card-active"
                : ""
            }`}
            onClick={() => {
              setActiveAdminPanel(
                activeAdminPanel === key ? null : key
              );
            }}
          >

            <div className="admin-card-icon">
              {panel.icon}
            </div>

            <div className="admin-card-text">

              <h3>
                {panel.title}
              </h3>

              <p>
                {panel.description}
              </p>

            </div>

            <span className="admin-card-arrow">
              {activeAdminPanel === key ? "↓" : "→"}
            </span>

          </button>

        ))}

      </div>

      {/* ACTIVE ADMIN PANEL */}

      {activeAdminPanel && adminPanels[activeAdminPanel] && (

        <div className="admin-expanded-panel">

          <div className="admin-expanded-header">

            <div className="admin-expanded-title">

              <div className="admin-expanded-icon">
                {adminPanels[activeAdminPanel].icon}
              </div>

              <div>
                <span className="section-label admin-label">
                  ADMIN PANEL
                </span>

                <h2>
                  {adminPanels[activeAdminPanel].title}
                </h2>
              </div>

            </div>

            <button
              className="admin-close-button"
              onClick={() => {
                setActiveAdminPanel(null);
              }}
            >
              ✕
            </button>

          </div>

          {adminPanels[activeAdminPanel].content}

        </div>

      )}

    </section>

  )}

  {/* =========================
      NETWORK INFO
  ========================= */}

  <div className="dashboard-info">

    <div className="dashboard-info-icon">
      ⚡
    </div>

    <div>

      <span className="section-label">
        VORTEX NETWORK
      </span>

      <h3>
        Everything in one place
      </h3>

      <p>
        Monitor your community, addons, downloads
        and server activity from your Vortex Network dashboard.
      </p>

    </div>

  </div>

</div>


);
}
